import { render } from "./EmployeeSubunitWidget.vue?vue&type=template&id=ffd934a8&scoped=true"
import script from "./EmployeeSubunitWidget.vue?vue&type=script&lang=js"
export * from "./EmployeeSubunitWidget.vue?vue&type=script&lang=js"

import "./EmployeeSubunitWidget.vue?vue&type=style&index=0&id=ffd934a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd934a8"]])

export default __exports__